import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledMedicalDeviceOrderForm = styled.form`
   display: flex;
`;
StyledMedicalDeviceOrderForm.displayName = 'StyledMedicalDeviceOrderForm';

export const StyledMedicalDeviceOrderFormFieldsSection = styled(StyledFlex)`
   max-width: 750px;
   width: 100%;
   padding-bottom: 12px;
   flex: 1 0 65%;
`;
StyledMedicalDeviceOrderFormFieldsSection.displayName = 'StyledMedicalDeviceOrderFormFieldsSection';

export const StyledMedicalDeviceOrderDocumentVerificationErrorsSection = styled(StyledFlex)`
   flex: 1 1 35%;
   padding-right: 10px;
`;
StyledMedicalDeviceOrderDocumentVerificationErrorsSection.displayName =
   'StyledMedicalDeviceOrderDocumentVerificationErrorsSection';
